import { VServiceAndInfraRemote } from "../api/services-and-infra";
import { VServiceAndInfra } from "../common/services-and-infra";

export function mapVServiceAndInfraRemoteToDomain(remote: VServiceAndInfraRemote): VServiceAndInfra {
  return {
    road: remote.road,
    statusAndQuality: remote.status_n_quality,
    accessPoints: remote.access_points,
    lengthOfRoad: remote.length_of_road,
    ownership: remote.ownership,
    centralHeating: remote.central_heating,
    heatings: remote.heatings.map(item => Number(item)),
    otherHeating: remote.other_heating,
    allOfIt: remote.all_of_it,
    services: remote.services.map(item => Number(item)),
    otherServices: remote.other_service
  }
}